import React, { useEffect } from 'react';

import { YOTPO_REVIEWS_INSTANCE_ID } from '../../api/constants';

type Props = {
  productRef: string;
  productName: string;
  url: string;
  imageUrl: string;
  productDescription?: string;
  price?: number;
};

export const YotpoReviews = ({
  productRef,
  productName,
  url,
  imageUrl,
  productDescription,
  price,
}: Props) => {
  useEffect(() => {
    (window as any).yotpoWidgetsContainer?.initWidgets();
  }, [productRef]);

  return (
    <div
      className="yotpo-widget-instance"
      data-yotpo-instance-id={YOTPO_REVIEWS_INSTANCE_ID}
      data-yotpo-product-id={productRef}
      data-yotpo-name={productName}
      data-yotpo-url={url}
      data-yotpo-image-url={imageUrl}
      data-yotpo-description={productDescription}
      data-yotpo-price={price?.toString()}
      data-yotpo-currency="EUR"
    />
  );
};
